module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "location"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.activity.city) + ", "), (_vm.activityRegion) ? _c('span', [_vm._v(_vm._s(_vm.activityRegion) + ",")]) : _vm._e(), _vm._v(" Portugal")]), _vm._v(" "), _c('div', {
    staticClass: "activityIcons m-t-1"
  }, [_c('div', [(_vm.activity.allows_instant_booking) ? _c('span', [_c('i', {
    staticClass: "fa fa-bolt"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.t('Allows instant booking')))])]) : _vm._e(), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.humanDuration) + "\n      ")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-child"
  }), _vm._v(" "), (_vm.activity.minimum_age != 0) ? _c('span', [_vm._v(_vm._s(_vm.t('Minimum age')) + ": " + _vm._s(_vm.activity.minimum_age) + " " + _vm._s(_vm.t('years old')))]) : _c('span', [_vm._v(_vm._s(_vm.t('Allows any age')))])]), _vm._v(" "), _c('span', [(_vm.activity.translations[_vm.language].spoken_languages) ? _c('i', {
    staticClass: "fa fa-comments-o"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.activity.translations[_vm.language].spoken_languages) + "\n      ")])]), _vm._v(" "), _c('div', [(_vm.activity.is_nature_tourism) ? _c('span', [_c('i', {
    staticClass: "fa fa-tree"
  }), _vm._v(" " + _vm._s(_vm.t('Activity recognized as Nature Tourism')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.activity.is_low_mobility_accessible) ? _c('span', [_c('i', {
    staticClass: "fa fa-wheelchair"
  }), _vm._v(" " + _vm._s(_vm.t('Accessible to low mobility people')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.activity.is_priced_per_occurrence) ? _c('span', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" " + _vm._s(_vm.t('Group activity')) + " (" + _vm._s(_vm.activity.group_min) + " – " + _vm._s(_vm.activity.group_max) + " " + _vm._s(_vm.t('participants')) + ")\n      ")]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b1bcd95a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1bcd95a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/DescriptionHeader.vue
// module id = 800
// module chunks = 3